<template>
  <div>
    <div v-show="value">
      <div class="noticeInScope dark:bg-purple-600 border-2" role="dialog">
        <div class="flexNoChange border-b border-solid mb-4 dark:text-white">
          <div class="flexDisplayNoChange">
            <h2 style="font-weight: 500; align-self: center">
              Service Details
            </h2>
          </div>
          <div class="flexDisplayNoChange" style="padding: 0">
            <div class="modalButton">
              <button v-on:click="close">
                <div class="cursor-pointer float-right">
                  <svg
                    width="36"
                    height="43"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="18" cy="18" r="18" fill="#F2F2F2" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
                      fill="#0C0707"
                      stroke="#3F3D56"
                      stroke-linecap="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
                      fill="#0C0707"
                      stroke="#3F3D56"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="flex dark:text-white" style="margin-bottom: 1rem">
          <div class="flexDisplay">
            <h3 class="flexDisplayh3 dark:text-gray-300">Title</h3>
            <h4>{{ modalTitle }}</h4>
          </div>

          <div v-if="email !== null && email !== blank">
            <div class="flexDisplay dark:text-service-title">
              <h3 class="flexDisplayh3 dark:text-gray-300">Email</h3>
              <span class="deliveryTags">{{ email }}</span>
            </div>
          </div>

          <div class="flexDisplay">
            <div v-if="phone !== null && phone !== blank">
              <h3 class="flexDisplayh3 dark:text-gray-300">Phone</h3>
              <span class="deliveryTags dark:text-black">{{ phone }}</span>
            </div>
          </div>

          <div
            v-if="modalDelivery1[0] !== blank && modalDelivery1[0] !== none"
            class="flexDisplay"
          >
            <h3 class="flexDisplayh3 dark:text-gray-300">Service Delivery</h3>
            <div style="display: flex">
              <p v-if="modalDelivery1 !== null" class="inlineFlex">
                <span v-for="modality in covert_modalDelivery" :key="modality">
                  <span class="deliveryTags">{{ modality }}</span>
                </span>
              </p>
              <p v-else class="inlineFlex">
                <span class="deliveryTags">{{ modalDelivery2 }}</span>
              </p>
            </div>
          </div>

          <div class="flexDisplay widthChange">
            <h3 class="flexDisplayh3 dark:text-gray-300">Description</h3>
            <p class="dark:text-white" v-html="remove_p"></p>
          </div>
        </div>
        <a
          :title="visit + modalTitle + website"
          class="visitWebsiteLink_a_tag"
          :href="modalLink"
          @click="trackServiceClick()"
          target="_blank"
          >Visit Website
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg> </span
        ></a>
      </div>
      <div v-on:click="close" class="modalOverlayClose"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    modalTheme: {
      type: String,
      required: false,
    },
    modalDescription: {
      type: String,
      required: false,
    },
    modalTitle: {
      required: false,
      type: String,
    },
    modalLink: {
      required: false,
      type: String,
    },
    modalDelivery1: {
      required: false,
      type: Array,
    },
    modalDelivery2: {
      required: false,
      type: String,
    },

    phone: {
      required: false,
      type: String,
    },

    email: {
      required: false,
      type: String,
    },

    modalView: {
      required: false,
      type: String,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { visit: "Visit ", website: " website", blank: "", none: "none" };
  },
  methods: {
    trackServiceClick() {
      this.$gtag.event('ServiceModal', {
        'event_category': 'resultService',
        'event_label': this.modalTitle,
      });
    },
    close() {
      document.title = "Wellness Navigator - Carleton University";
      this.$emit("input", !this.value);
    },
  },

  computed: {
    remove_p: function () {
      return this.modalDescription.replace("<p>", "");
    },

    covert_modalDelivery: function () {
      var covertedVals = Object.values(this.modalDelivery1);

      for (var i = 0; i < covertedVals.length; i++) {
        if (covertedVals[i] === "phone") {
          covertedVals[i] = "Phone Call ";
        } else if (covertedVals[i] === "email") {
          covertedVals[i] = "Email";
        } else if (covertedVals[i] === "text") {
          covertedVals[i] = "Text";
        } else if (covertedVals[i] === "video") {
          covertedVals[i] = "Video Chat";
        } else if (covertedVals[i] === "person") {
          covertedVals[i] = "In Person";
        } else if (covertedVals[i] === "self") {
          covertedVals[i] = "Self-Directed Learning";
        } else if (covertedVals[i] === "app") {
          covertedVals[i] = "App";
        } else if (covertedVals[i] === "website") {
          covertedVals[i] = "Website";
        }
      }

      return covertedVals;
    },
  },
};
</script>

<style lang="css" scoped>
.noticeInScope {
  @apply fixed p-8 bg-white rounded-3xl shadow-lg z-50 max-w-4xl;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: left;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
}

@media only screen and (max-width: 940px) {
  .noticeInScope {
    width: 90%;
  }
}

@media only screen and (max-width: 640px) {
  .noticeInScope {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    @apply p-4;
  }
}
</style>
